import styled from "styled-components";
import logo from "../Images/RM logo.png";
import "../Styles/fonts.css";

function footer() {
  const handlePrivacyPolicyClick = () => {
    const newWindow = window.open("", "_blank", "width=800,height=600");
    newWindow.document.write(`
      <html>
        <head>
          <title>개인정보처리방침</title>
        </head>
        <body>
          <iframe 
            src="${process.env.PUBLIC_URL}/대시보드_개인정보처리방침.html" 
            width="100%" 
            height="100%" 
            style="border:none;"
          ></iframe>
        </body>
      </html>
    `);
    newWindow.document.close();
  };

  const handleTermsofUseClick = () => {
    const newWindow = window.open("", "_blank", "width=800,height=600");
    newWindow.document.write(`
      <html>
        <head>
          <title>이용약관</title>
        </head>
        <body>
          <iframe 
            src="${process.env.PUBLIC_URL}/대시보드_이용약관.html" 
            width="100%" 
            height="100%" 
            style="border:none;"
          ></iframe>
        </body>
      </html>
    `);
    newWindow.document.close();
  };
  return (
    <FooterBox>
      <Menubar>
        <a href="/RMweb">플랜 요금제</a>
        <div className="line" />
        <a href="http://runpoint.co.kr/" target="_blank">
          회사소개
        </a>
        <div className="line" />
        <p onClick={handleTermsofUseClick}>이용약관</p>
        <div className="line" />
        <p onClick={handlePrivacyPolicyClick}>개인정보처리방침</p>
      </Menubar>
      <InfoBox>
        <a href="https://web.rankingmarathon.com/">
          <img src={logo} alt="RM logo" />
        </a>
        <p style={{ marginTop: "20px" }}>© 러닝포인트 ALL RIGHTS RESERVED.</p>
        <p style={{ lineHeight: "160%" }}>
          (주) 러닝포인트 | 대표 박태훈 | 서울특별시 금천구 가산디지털1로
          205-15, SH드림타워 1007호, 1008호
          <br />
          5층 사업자등록번호 : 515-81-56247 <br />
          통신판매업 신고 : 제2020-서울마포-4175호 <br />
          연락처 : 010-5725-6820 | 문의 이메일 : info@runpoint.co.kr
        </p>
      </InfoBox>
    </FooterBox>
  );
}

const FooterBox = styled.div`
  width: 100%;
  height: 100vh;
  max-height: 371px;
  background-color: #ffffff;
`;

const Menubar = styled.div`
  width: 80%;
  height: 26px;
  margin-left: 320px;
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  > p {
    font-family: "notoSans-bold";
    font-size: 18px;
    color: #777777;
    white-space: pre-wrap;
    cursor: pointer;
  }
  > a {
    font-family: "notoSans-bold";
    font-size: 18px;
    color: #777777;
    white-space: pre-wrap;
    cursor: pointer;
    text-decoration: none;
  }
  .line {
    border-left: 1px solid #bbbbbb;
    height: 13px;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 4px;
    align-self: center;
  }
`;

const InfoBox = styled.div`
  width: 80%;
  height: 205px;
  margin-left: 320px;
  margin-top: 40px;
  padding: 0;
  border-top: 2px solid #f2f2f2;

  > a {
    display: inline-block;
    margin-top: 42px;
  }
  > a > img {
    display: block;
  }
  > p {
    font-family: "notoSans";
    font-size: 13;
    letter-spacing: 0.04em;
    color: #888888;
  }
`;

export default footer;
